import React from 'react';
import { FormattedMessage } from 'react-intl';

import theme from './TabContentFailure.scss';

export default () => (
  <div className={ theme.root }>
    <span className={ theme.message }>
      <FormattedMessage id="patientHistory.noConnctionMessage" defaultMessage="** There is an issue connecting to the service" />
    </span>
  </div>
);

